export const iconFontAwesomeLogisticsCartFlatbed = (
	<i className="fa-solid fa-cart-flatbed"></i>
);
